var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"mb-3"},[_c('router-view',{staticClass:"mt-14 mb-16"})],1),_c('BottomNavigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }